import buttonModel from './assets/button-combine.glb?url';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import * as THREE from 'three';
import gsap from 'gsap';

export class MenuCombineButton {
  public model?: THREE.Object3D;

  constructor(visible: boolean) {
    const loader = new GLTFLoader();
    const setModel = this.setModel.bind(this);
    loader.load(
      buttonModel,
      function (gltf: GLTF) {
        setModel(gltf.scene.children[0], visible);
      }.bind(this),
      undefined,
      function (error) {
        console.error(error);
      }
    );
  }

  private setModel(model: THREE.Object3D, visible: boolean) {
    this.model = model;
    this.setVisible(visible);
  }

  public setVisible(visible: boolean) {
    if (!this.model) return;
    this.model.visible = visible;
  }

  public outAnimation() {
    if (!this.model) return;

    gsap.to(this.model.position, {
      y: '-=5',
      duration: 0.3,
      onComplete: () => this.setVisible(false),
    });
  }
}
